export default function EcosystemMap() {
  const nodes = [
    {
      title: 'Ultimate Freestyle War',
      subtitle: 'Competition Engine',
      icon: 'ri-trophy-line',
      color: 'from-orange-500 to-orange-600',
      position: 'left'
    },
    {
      title: 'Story &amp; Technology Core',
      subtitle: 'Five Elements + Magda + Unreal + AI',
      icon: 'ri-galaxy-line',
      color: 'from-cyan-400 to-blue-500',
      position: 'center'
    },
    {
      title: 'Elemental Harmony Workshop',
      subtitle: 'Corporate Experience Engine',
      icon: 'ri-team-line',
      color: 'from-green-400 to-emerald-500',
      position: 'right'
    }
  ];

  return (
    <section className="py-32 bg-[#0A0A0F] relative overflow-hidden">
      {/* Background Grid */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'linear-gradient(rgba(6, 182, 212, 0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(6, 182, 212, 0.1) 1px, transparent 1px)',
          backgroundSize: '50px 50px'
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <h2 className="text-5xl md:text-6xl font-bold text-white text-center mb-20">
          The Groove &amp; Glow Ecosystem
        </h2>

        <div className="relative">
          {/* Connection Lines */}
          <div className="hidden md:block absolute top-1/2 left-0 right-0 h-1 bg-gradient-to-r from-orange-500 via-cyan-400 to-green-500 opacity-30 -translate-y-1/2"></div>

          {/* Nodes */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative z-10">
            {nodes.map((node, index) => (
              <div 
                key={index}
                className="group relative"
              >
                <div className={`bg-gradient-to-br ${node.color} p-1 rounded-3xl hover:scale-105 transition-transform duration-300`}>
                  <div className="bg-[#0F0F1A] rounded-3xl p-10 h-full">
                    <div className="w-20 h-20 rounded-full bg-gradient-to-br ${node.color} flex items-center justify-center mb-8 mx-auto group-hover:rotate-12 transition-transform duration-300">
                      <i className={`${node.icon} text-4xl text-white`}></i>
                    </div>
                    
                    <h3 className="text-2xl font-bold text-white text-center mb-3" dangerouslySetInnerHTML={{ __html: node.title }}></h3>
                    <p className="text-gray-400 text-center text-sm" dangerouslySetInnerHTML={{ __html: node.subtitle }}></p>
                  </div>
                </div>

                {/* Connector Dots */}
                {index < 2 && (
                  <div className="hidden md:block absolute top-1/2 -right-6 w-12 h-1 bg-gradient-to-r from-cyan-400 to-transparent opacity-50 -translate-y-1/2"></div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-8">
          <p className="text-xl text-cyan-400 font-light tracking-wider">
            One universe. Multiple entry points. One evolving platform.
          </p>
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <a 
            href="#contact" 
            className="inline-flex items-center gap-3 px-10 py-4 bg-gradient-to-r from-orange-500 to-orange-600 rounded-full text-white font-bold text-lg hover:shadow-2xl hover:shadow-orange-500/50 transition-all hover:-translate-y-1 cursor-pointer whitespace-nowrap"
          >
            Learn More About The Ecosystem
            <i className="ri-arrow-right-line text-xl"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
